export { HeroColorBlock } from './HeroColorBlock';
export type { Props as HeroColorBlockProps } from './HeroColorBlock';
